export default class Brand {
  #data

  constructor (paramsJson, paramsFromApi) {
    this.#data = {
      ...paramsJson,
      ...paramsFromApi
    }
  }

  get id () {
    return this.#data.id
  }

  get name () {
    return this.#data.brandName
  }

  get code () {
    return this.#data.brandCode
  }

  get link () {
    return this.#data.meta?.link
  }

  get logo () {
    return `/logos/${this.#data.brandCode}.svg`
  }

  get logoWhite () {
    return `/logos/${this.#data.brandCode}-white.svg`
  }

  get colorPrimary () {
    return this.#data.colors.primary
  }

  get colorPrimaryHover () {
    return this.#data.colors.primaryHover
  }

  get colorWhiteHover () {
    return this.#data.colors.whiteHover
  }

  get colorConfetti () {
    return this.#data.colors.confetti
  }

  get radioLink () {
    return this.#data.radioLink
  }
}
